<template>
  <b-row>
    <b-col cols="" class="card-box" :class="expanded ? 'h-61vh' : 'h-64vh'">
      <div class="body-box">
        <div class="">
          <div class="text-muted mb-2">شرکت</div>
          <p class="text-dark font-weight-bold ml-2">
            {{ checkItem(["company_name"]) }}
          </p>
        </div>
        <div class="">
          <div class="text-muted mb-2">شغل</div>
          <p class="text-dark font-weight-bold ml-2">
            <small class="text-muted">عنوان شغلی یا سمت:</small><br />
            {{ checkItem(["jobs", "position"]) }}
          </p>
          <p class="text-dark font-weight-bold ml-2">
            <small class="text-muted">سطح شغلی:</small><br />

            {{ checkItem(["jobs", "job_level", "caption"]) }}
          </p>
          <p class="text-dark font-weight-bold ml-2">
            <small class="text-muted">رسته شغلی:</small><br />
            {{ checkItem(["jobs", "job_category"]) }}
          </p>
        </div>
        <div class="">
          <div class="text-muted mb-2">تحصیلات</div>
          <p class="text-dark font-weight-bold ml-2">
            {{ checkItem(["educations", "education_field"]) }}
          </p>
          <p class="text-dark font-weight-bold ml-2">
            {{ checkItem(["educations", "grade", "caption"]) }}
          </p>
        </div>
      </div>
      <slot name="user-box"></slot>
    </b-col>
    <b-col v-if="expanded" cols="7" class="">
      <p class="text-justify text-dark">
        {{ checkItem(["description"]) }}
      </p>
      <hr />
      <div
        class="text-left text-dark"
        v-for="(report, reportIndex) in item.reports"
        :key="`b-${reportIndex}`"
      >
        <mdicon name="file-pdf-box" size="20" class="mr-2" />
        <a :href="pathOr('#', ['download_link'], report)" target="_black">
          {{ checkItem(["caption"], report) }}
        </a>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { pathOr } from "ramda";

export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    pathOr,
    checkItem(key, item = null) {
      const data = item || this.item;
      return pathOr(null, key, data) || "ندارد";
    },
  },
};
</script>
<style lang="scss" scoped>
.card-box {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.h-64vh {
  height: 64vh;
}
.h-61vh {
  height: 61vh;
}
</style>
